'use client';

import { CollapsablePanel } from '@app/app/_components/CollapsablePanel/CollapsablePanel';
import { ReadOnlyField } from '@app/app/_components/ReadOnlyField/ReadOnlyField';
import { VehicleInformation } from '@app/domain/model/eshop/transport/VehicleInformation';
import { FormState } from '@app/lib/form/contracts/FormState';
import { convertCCtoLitre } from '@app/lib/unit-converter/convertCCtoLitre';
import { PurchaseTransportInsuranceResult } from '@app/service/eshop/transport/actions/purchaseTransportInsurance';
import { useTranslations } from 'next-intl';

interface Props {
    vehicleInformation: VehicleInformation;
    formState: FormState<PurchaseTransportInsuranceResult>;
    defaultCollapsed?: boolean;
    collapsable?: boolean;
}

export function VehicleInformationPanel({
    vehicleInformation,
    formState,
    defaultCollapsed = true,
    collapsable = true,
}: Props) {
    const t = useTranslations();

    return (
        <CollapsablePanel
            collapsable={collapsable}
            defaultCollapsed={defaultCollapsed}
            label={`${vehicleInformation.make} ${formState.data?.formData.modelCASCO ?? vehicleInformation.modelCASCO ?? ''} / ${vehicleInformation.licencePlate} / ${vehicleInformation.manufactureYear}`}>
            <div className="grid grid-cols-1 gap-4 px-6 pt-2 xs:grid-cols-2">
                <ReadOnlyField label={t('eshop.transport.vehicleModelLabel')}>
                    {formState.data?.formData.modelCASCO ?? vehicleInformation.modelCASCO}
                </ReadOnlyField>
                <ReadOnlyField label={t('eshop.transport.vehicleYearLabel')}>
                    {vehicleInformation.manufactureYear}
                </ReadOnlyField>
                <ReadOnlyField label={t('eshop.transport.vehicleWeightLabel')}>
                    {t('general.units.kg', { value: vehicleInformation.weight })}
                </ReadOnlyField>
                <ReadOnlyField label={t('eshop.transport.vehiclePowerLabel')}>
                    {t('general.units.kw', { value: vehicleInformation.enginePower })}
                </ReadOnlyField>
                <ReadOnlyField label={t('eshop.transport.vehicleEngineLabel')}>
                    {t('general.units.litre', {
                        value: convertCCtoLitre(vehicleInformation.engineCapacity ?? 0).toFixed(1),
                    })}
                </ReadOnlyField>
            </div>
        </CollapsablePanel>
    );
}
